import useNavigate from '@/hooks/router/useNavigate';
import { Paper, styled, Typography } from '@mui/material';
import { AuthorizationForm, ClientConfigurationContext } from '@ngt/openiddict'
import { FC, useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const Authorization: FC = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    const onCancel = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.authorizations ?? '/');
    }, [navigate, clientConfiguration?.administrationUris?.authorizations])

    const afterDelete = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.authorizations ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.authorizations]);

    const afterSubmit = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.authorizations ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.authorizations])

    return (
        <>
            <Typography variant="h1" gutterBottom>
                Authorization
            </Typography>
            <StyledPaper>
                <AuthorizationForm
                    id={id && !isNaN(+id) ? +id : undefined}
                    afterDelete={afterDelete}
                    afterSubmit={afterSubmit}
                    onCancel={onCancel}
                    debug={import.meta.env.DEV}
                />
            </StyledPaper>
        </>
    );
}

export default Authorization;